export interface RefundQuantityLine {
  productId: string;
  quantity: number;
}

/**
 * Units still on the sale after earlier refunds.
 * Each refund item is applied to the first matching sale line that still has quantity.
 */
export function remainingQuantities(
  saleItems: RefundQuantityLine[],
  priorRefunds: Array<{ items: RefundQuantityLine[] }>,
): number[] {
  const left = saleItems.map((item) => item.quantity);
  for (const refund of priorRefunds) {
    for (const item of refund.items) {
      let need = item.quantity;
      for (let i = 0; i < saleItems.length && need > 0; i++) {
        if (saleItems[i].productId !== item.productId || left[i] <= 0) continue;
        const take = Math.min(left[i], need);
        left[i] -= take;
        need -= take;
      }
    }
  }
  return left;
}

/** Throws a message when a requested line exceeds what is still on the sale. */
export function assertRefundQuantitiesAvailable(
  saleItems: RefundQuantityLine[],
  priorRefunds: Array<{ items: RefundQuantityLine[] }>,
  requested: RefundQuantityLine[],
): number[] {
  const left = remainingQuantities(saleItems, priorRefunds);
  const pool = [...left];
  for (const item of requested) {
    let need = item.quantity;
    for (let i = 0; i < saleItems.length && need > 0; i++) {
      if (saleItems[i].productId !== item.productId || pool[i] <= 0) continue;
      const take = Math.min(pool[i], need);
      pool[i] -= take;
      need -= take;
    }
    if (need > 0) {
      throw new Error(`Quantity already returned for ${item.productId}`);
    }
  }
  return left;
}
